(function () {
    'use strict';

    var scrollTo = function ($log, scrollingService) {
        var linker = function (scope, element, attrs) {

            var onElementClick = function () {
                scrollingService.scrollTo(attrs["scrollTo"], attrs["scrollOffset"], attrs["scrollDuration"], attrs["scrollEasing"]);
            };

            element.on('click', onElementClick);

            scope.$on('$destroy', function () {
                element.off('click', onElementClick);
            });
        };

        return {
            restrict: 'A',
            link: linker,
            scope: {}
        };
    };

    scrollTo.$inject = ['$log', 'scrollingService'];
    angular.module('ecap.common').directive('scrollTo', scrollTo);
})();